import { TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

export const StartPageWrapper = styled.div`
    width: 50%;
`;

export const DateTimeWrapper = styled.div`
    display: flex;
    gap: 16px;

    > div {
        flex: 1;
    }
`;

export const SwitchesWrapper = styled.div`
    display: flex;
    gap: 47px;
`;

export const SwitchItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SwitchLabel = styled.div`
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize}
    ${DESKTOP_SIZES[SIZES.BODY_XL].fontWeight}
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight}
    ${FONT_FAMILY.poppins};
    color: ${TC.body};
`;

export const ButtonWrapper = styled.div`
    display: flex;
    gap: 16px;
    margin-top: 24px;

    button {
        width: 88px;

        span {
            ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize}
        }
    }
`;
